import { Component, OnInit, ViewChild, NgZone  } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../services/api/api.service';
import { ToastService } from '../services/toast/toast.service';

@Component({
  selector: 'app-bulk-order',
  templateUrl: './bulk-order.page.html',
  styleUrls: ['./bulk-order.page.scss'],
})
export class BulkOrderPage implements OnInit {
  catgNameList:any = []

  catgItemList:any = []

  myCustomIcon:any = "../../assets/icon/favicon.png";
  myDiscountIcon:any = "../../assets/img/offer_bg.svg";

  catgList = {
    initialSlide: 0,
    slidesPerView: 1,
    autoplay: false
  };

  data: any = false
  load_products:any = true
  canScrollToLoadMore:any = false
  paginationData:any= ''

  constructor(public toast: ToastService,public api: ApiService,public zone: NgZone) { 

  }

  ngOnInit() {
    try {
      this.api.getCategoryNameList().subscribe((result:any) => {
        if(result.status == true){
          if(result.data.length > 0){
            this.catgNameList = result.data
            this.catgNameList.forEach((element:any) => {
              if(element.category_name != "All"){
                element.selected = false
              }
              else{
                element.selected = true
              }
            });

            try {
              this.api.getAllProductsList().subscribe(async(result:any) => {
                if(result.status == true){
                  if(result.data.length > 0){
                    this.catgItemList = result.data
                    this.paginationData = result.links
                    if(result.links.next != null){
                      this.canScrollToLoadMore = true
                    }
                    else{
                      this.canScrollToLoadMore = false
                    }
                  }
                  else{
                    if(result.links.next != null){
                      this.canScrollToLoadMore = true
                    }
                    else{
                      this.canScrollToLoadMore = false
                    }
                  }
                }
                this.data = true
              },(err)=>{
                this.data = true
                console.log(err)
              });
            }
            catch (error) {
              this.data = true
              console.error('Here is the error message', error);
            }
          }
        }
      },(err)=>{
        console.log(err)
      });
    }
    catch (error) {
      console.error('Here is the error message', error);
    }
  }


  doInfinite(event:any){
    this.zone.run(() => {
      try {
        this.api.getProductsListWithPagination(this.paginationData.next).subscribe((result:any) => {
          if(result.status == true){
            if(result.data.length > 0){
              let temp:any = result.data
              this.paginationData = result.links
              for(let i = 0; i < temp.length; i++){
                this.catgItemList.push(temp[i])
              }
              if(result.links.next != null){
                this.canScrollToLoadMore = true
              }
              else{
                this.canScrollToLoadMore = false
              }
            }
          }
          event.target.complete();
        },(err)=>{
          event.target.complete();
          console.log(err)
        });
      }
      catch (error) {
        event.target.complete();
        console.error('Here is the error message', error);
      }
    })
  }

  showCategoryItems(index:any){
    this.zone.run(() => {
      this.load_products = false
      this.catgItemList = []
      for(let i = 0; i < this.catgNameList.length; i++){
        if(i == index){
          this.catgNameList[i].selected = true
        }
        else{
          this.catgNameList[i].selected = false
        }
      }
      if(this.catgNameList[index].id != 1){
        try {
          this.api.getSpecificCatgProductList(this.catgNameList[index].id).subscribe((result:any) => {
            if(result.status == true){
              if(result.data.length > 0){
                this.catgItemList = result.data
                this.paginationData = result.links
                if(result.links.next != null){
                  this.canScrollToLoadMore = true
                }
                else{
                  this.canScrollToLoadMore = false
                }
              }
              else{
                if(result.links.next != null){
                  this.canScrollToLoadMore = true
                }
                else{
                  this.canScrollToLoadMore = false
                }
              }
            }
            this.load_products = true
          },(err)=>{
            this.load_products = true
            console.log(err)
          });
        }
        catch (error) {
          this.load_products = true
          console.error('Here is the error message', error);
        }
      }
      else{
        try {
          this.api.getAllProductsList().subscribe((result:any) => {
            if(result.status == true){
              if(result.data.length > 0){
                this.catgItemList = result.data
                this.paginationData = result.links
                if(result.links.next != null){
                  this.canScrollToLoadMore = true
                }
                else{
                  this.canScrollToLoadMore = false
                }
              }
              else{
                if(result.links.next != null){
                  this.canScrollToLoadMore = true
                }
                else{
                  this.canScrollToLoadMore = false
                }
              }
            }
            this.load_products = true
          },(err)=>{
            this.load_products = true
            console.log(err)
          });
        }
        catch (error) {
          this.load_products = true
          console.error('Here is the error message', error);
        }
      }
    })
  }

  AddToCart(value:any,index:any){
  }

  reduceQuantity(value:any,index:any){
  }

  addQuantity(value:any,index:any){
  }



}
